/**
 * @returns The access token required for Mina Sidor-API.
 */
export function getAccessToken(): string | null {
  return window.localStorage.getItem('minasidor_token') || null;
}

/**
 * @returns The session id required for BankID authentication.
 */
export function getSessionId(): string | null {
  return window.localStorage.getItem('minasidor_session_id') || null;
}

/**
 * Makes a request to Mina Sidor-API.
 * Automatically sets access token.
 * @param method HTTP verb.
 * @param url Relative API URL.
 * @param data For POST or PUT requests, API body.
 */
export async function callMinaSidorApi<T>(method: 'get' | 'post', url: string, data?: any): Promise<T> {
  const relativeUrl = '/api/minasidor/' + url.replace(/^\//, '');
  const urlObject = new URL(relativeUrl, "https://salesys.se");
  urlObject.searchParams.set('t', Date.now().toString()); // SiteGround has en inbyggd cache som ställer till det med BankID, m.m.
  const response = await fetch(urlObject.href, {
    method,
    headers: {
      "content-type": "application/json",
      accept: "application/json",
      authorization: getAccessToken() // Denna identifierar dig som inloggad kund.
    },
    body: method === 'post' ? JSON.stringify(data) : undefined
  });
  const responseText = await response.text();

  let json: any = null;
  try {
    //  Försök att göra om det vi får från API:et till JSON, och om det misslyckas (vid catch), kasta ett eget error.
    json = JSON.parse(responseText);

    if (typeof json === "string") {
      //  Dom skickar JSON lite konstigt ibland, ett objekt i form av en stäng.
      json = JSON.parse(json);
    }
  } catch (error) {
    throw new Error(`Mina Sidor-API response has invalid JSON: ${response.status} ${response.statusText} ${responseText}`);
  }

  if (typeof json?.short_code === 'string' && !json.short_code.startsWith('2')) {
    throw new Error(`Mina Sidor-API gave error: ${json.description}`);
  }

  if (json?.error) {
    throw json;
  }
  
  if (!response.ok) {
    throw new Error(`Mina Sidor-API response not OK: ${response.status} ${response.statusText} ${responseText}`);
  }

  return json;
}